import { formCategories } from "./../../helpers/index.js";
// Type-only import: erased at compile time, so it does not create a runtime cycle with
// forms.schema.ts (which imports `templateEditCases` from this file).
import type { FormFlowStep } from "./forms.schema.js";

export const templateEditCases = {
  EDIT_SECTION_HEADING: "EDIT_SECTION_HEADING",
  DELETE_SECTION: "DELETE_SECTION",
  CONFIGURE_SECTION: "CONFIGURE_SECTION",
  CHANGE_SECTION_SEQUENCE: "CHANGE_SECTION_SEQUENCE",
  EDIT_QUESTION: "EDIT_QUESTION",
  ADD_QUESTION: "ADD_QUESTION",
  DELETE_QUESTION: "DELETE_QUESTION",
  CONFIGURE_QUESTION: "CONFIGURE_QUESTION",
  CHANGE_QUESTION_SEQUENCE: "CHANGE_QUESTION_SEQUENCE",
} as const;
export const preDefinedFormCategories = [
  formCategories.bills,
  formCategories.inspection,
  formCategories.progressUpdates,
  formCategories.changeOrder,
  formCategories.issues,
  formCategories.mailBox,
  formCategories.projects,
  formCategories.model,
  formCategories.reviews,
  formCategories.contract,
  formCategories.files,
];

export const formCategoryFieldValueMapper: Record<string, { quantity: string; amount: string; percent: string }> = {
  [formCategories.inspection]: {
    quantity: "inspectedQuantity",
    amount: "inspectedAmount",
    percent: "inspectedPercentageOfTotal",
  },
  [formCategories.progressUpdates]: {
    quantity: "usedQuantity",
    amount: "usedAmount",
    percent: "usedPercentageOfTotal",
  },
  [formCategories.bills]: {
    quantity: "billedQuantity",
    amount: "billedAmount",
    percent: "billedPercentageOfTotal",
  },
};

export const formStatuses = {
  inProgress: "IN_PROGRESS",
  rejected: "REJECTED",
  approved: "APPROVED",
  submitted: "SUBMITTED",
} as const;

export const formCounterMapper: Record<string, string> = {
  [formCategories.inspection]: "inspectionsCounter",
  [formCategories.progressUpdates]: "progressUpdatesCounter",
  [formCategories.bills]: "billsCounter",
  [formCategories.changeOrder]: "changeOrdersCounter",
  [formCategories.payments]: "paymentsCounter",
};

export default {
  templateEditCases,
  formStatuses,
  formCategoryFieldValueMapper,
  formCounterMapper,
  preDefinedFormCategories,
};
// The two-level default form flow used when a form flow is created without an explicit one
// (saveFormFlow's auto-generate branch). Shape is a form-flow level, so it derives from
// `formFlowLevelSchema` in forms.schema.ts via its exported `FormFlowStep` type rather than
// re-declaring the level shape here.
export const initialFormValue: FormFlowStep[] = [
  {
    heading: "Pre-Submission",
    dataSource: [],
    submitBtnTxt: "Submit",
    allowedUsersToSubmit: [],
    rejectBtnTxt: "Reject",
    allowedUsersToReject: [],
    actionStatus: false,
    actionDetails: {},
  },
  {
    heading: "Post-submission",
    dataSource: [],
    rejectBtnTxt: "Reject",
    approveBtnTxt: "Approve",
    allowedUsersToApprove: [],
    allowDynamicUserConfig: false,
    allowedUsersToReject: [],
    actionStatus: false,
    actionDetails: {},
  },
];

// Upper bound on `removeFileUploadFieldData.awsKey`, so one request cannot fan out unbounded storage
// round-trips. Deliberately generous rather than tight: "Delete All" legitimately sends every file
// stored on the question, and `maxNoOfFiles` is per-question config with no ceiling of its own, so a
// small cap would break the feature. The real amplification guard is intersecting the list with the
// question's own stored keys before touching storage; this is only the outer limit.
export const MAX_FILE_KEYS_PER_REMOVAL = 500;
